const waistToHipData = [
    {
        id: 1,
        name: "دور کمر",
        unit: "سانتی متر"
    },
    {
        id: 2,
        name: "دور باسن",
        unit: "سانتی متر"
    }
]

export default waistToHipData